






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import feeTable from '@/views/lawsuit/feeTable.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import Task from '@/web-task'
import { zeroUnit } from '@/web-task/utils'
import { format } from '@/web-task/filter'
import { hasValue } from '@/utils/util'

@Component({
	components: {
		Info,
		InfoRow,
		feeTable,
		ImageList,
	},
})
export default class ResultInfo extends Vue {
	private resultInfo: any = {}
	private resultInfoSub1: any = []
	private resultInfoSub2: any = []

	@Prop()
	private order!: any

	@Prop()
	private injured!: any

	@Prop()
	private task!: any

	private get initialPlan(): any {
		let operationInfo = (this.injured && this.injured.operationInfo) || {}
		return {
			schemeList: operationInfo.schemeList,
			compulsorySum: operationInfo.compulsorySum,
			commercialSum: operationInfo.commercialSum,
			remark: operationInfo.schemeRemark,
		}
	}

	private get resultList() {
		// 是否为庭审
		let operationInfo = (this.injured && this.injured.operationInfo) || {}
		let isCourt = operationInfo.result === '0'
		let arr: Array<any> = []
		arr.push(
			{
				label: '处理方式',
				value: isCourt ? '庭审' : '调解',
			},
			{
				label: isCourt ? '庭审时间' : '调解时间',
				value: format(operationInfo.courtDate, 'YYYY-MM-DD HH:mm'),
			}
		)
		if (operationInfo.dispute) {
			arr.push({
				label: '案件争议点',
				value: operationInfo.dispute,
			})
		}
		if (hasValue(operationInfo.compensationSum)) {
			arr.push({
				label: '赔付总金额',
				value: zeroUnit(operationInfo.compensationSum, '元'),
			})
		}
		if (operationInfo.remark) {
			arr.push({
				label: '备注',
				value: operationInfo.remark,
			})
		}
		return arr
	}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		if (this.task instanceof Task) {
			this.resultInfo = this.task.getResultInfo()
			let rest = this.resultInfo.children.splice(
				this.resultInfo.children.findIndex((item: any) => {
					return item.label === '本方代理人'
				}),
				this.resultInfo.children.length
			)
			this.resultInfoSub1 = rest.slice(
				0,
				rest.findIndex((item: any) => {
					return item.label === '对方代理人'
				})
			)
			this.resultInfoSub2 = rest.slice(
				rest.findIndex((item: any) => {
					return item.label === '对方代理人'
				}),
				rest.length
			)
		}
	}
}
